<template>
  <div v-if="product">
    <select name="product-label-attach-kbn" v-model="product.goodsLabelAttachKbn" :disabled="isDisableEdit" :id="`product-label-attach-kbn-${product.asin}`" class="form-control" @change="update()">
      <option v-for="(arrItem, arrIndex) in arrAttachKbn" :key="arrIndex" :value="arrItem.id">{{ arrItem.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    isDisableEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      arrAttachKbn: [
        {
          id: '0',
          name: '自分で貼付ける'
        },
        {
          id: '1',
          name: 'セルモンに依頼する'
        }
      ]
    }
  },
  methods: {
    update () {
      this.$emit('update', this.product)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/GoodsLabelAttachKbnItem.vue